<template>
  <div class="SaleDemandList" v-title data-title="水产圈子买卖信息管理">
    <div class="pt5 text-left"><van-button size="small" class="btn-common" plain="" type="info"
              @click="back">返回</van-button></div>

    <div class="row align-items-center pr7">
      <div class="row align-items-center pt2">
        <div class="pl2 pr1">发布人</div>
        <input class="keywords-input" v-model="params.keywords" placeholder="手机、昵称、微信号"/>
      </div>
      <!-- <div class="row align-items-center pt2">
        <div class="pl2 pr1">类型</div>
        <select placeholder="请选择类型" v-model="params.accreditationStatus">
          <option v-for="option in SALE_TYPES" :key="option.value">
            {{option.text}}
          </option>
        </select>
      </div> -->
      <div class="row align-items-center pt2">
        <div class="pl2 pr1">状态</div>
        <select placeholder="请选择状态" v-model="params.status">
          <option v-for="option in statusOptions" :key="option.value" :value="option.value">
          {{option.text}}
        </option>
        </select>
      </div>
      <!-- <div class="row align-items-center pt2">
        <div class="pl2 pr1">注册时间</div>
        <input class="date-select" v-model="params.regStartDate" placeholder="yyyy-mm-dd" />-<input class="date-select" v-model="params.regEndDate" placeholder="yyyy-mm-dd" />
      </div> -->
      <div class="flex-1"></div>
      <div class="pt2 pl2">
        <van-button type="info" size="small" class="button"
                @click="getData()">查 询</van-button>
      </div>
    </div>
    <div class="row align-items-center pr7 pt5 pl3">
      <div class="font-bold flex-1 text-left">共{{(total||0)}}条买卖信息</div>
    </div>
    <van-list
      v-model="loading"
      :error.sync="error"
      error-text="请求失败，点击重新加载"
      :finished="finished"
      :finished-text="records.length > 10 ? '没有更多了' :''"
      @load="loadMore"
    >
      <div class="pt5 text-left">
        <div class="row align-items-baseline line pl1 font-bold">
          <div class="col-4 pr1 pt1 pb1">昵称</div>
          <div class="col-3 pr1 pt1 pb1">手机号</div>
          <div class="col-1 pr1 pt1 pb1">类型</div>
          <div class="col-2 pr1 pt1 pb1">有效期</div>
          <div class="col-5 pr1 pt1 pb1">内容</div>
          <div class="col-3 pr1 pt1 pb1">状态</div>
          <div class="col-4 pr1 pt1 pb1">更新时间</div>
          <div class="col-2 pr1 pt1 pb1">操作</div>
        </div>
        <div class="row align-items-baseline line pl1"
          v-for="(item) in records"
          :key="item.id"
        >
          <div class="col-4 pr1 pt1 pb1">{{item.nickname}}</div>
          <div class="col-3 pr1 pt1 pb1">{{item.phoneNumber}}</div>
          <div class="col-1 pr1 pt1 pb1">{{item.requirementName}}</div>
          <div class="col-2 pr1 pt1 pb1">{{item.requirementDurationName}}</div>
          <div class="col-5 pr1 pt1 pb1" v-html="item.requirementInfo.replaceAll('\n', '<br/>')"></div>
          <div class="col-3 pr1 pt1 pb1">{{item.statusName}}</div>
          <div class="col-4 pr1 pt1 pb1">{{item.updateTime}}</div>
          <div class="col-2 pr1 pt1 pb1">
            <van-button v-if="(item.status == STATUS.UNVERIFIED || item.status == STATUS.REFUSED)" size="mini" class="fc-success" @click="approveItem(item)">通过</van-button>
            <van-button v-if="(item.status != STATUS.REFUSED)" size="mini" class="fc-red" @click="refuseItem(item)">拒绝</van-button>
          </div>
        </div>
      </div>
    </van-list>

    <van-popup v-model="detailShow">内容</van-popup>
    <van-dialog v-model="rejectReasonShow" title="拒绝原因" @confirm="refuseSalesStatus">
      <input v-model="rejectReason" placeholder="请输入拒绝原因"/>
    </van-dialog>
  </div>
</template>

<script>
import Vue from 'vue';
import {
  sendRequest, getSalesList, refuseSalesStatus, approveSalesStatus, getSalesInit,
} from '../../network/NetworkAccessor';
import storage from '../../uitls/cacheUtil';
import config from '../../config';

const STATUS = {
  AUTO_APPROVED: 0,
  UNVERIFIED: 1,
  REFUSED: 3,
  APPROVED: 2,
};

const statusName = {
  [STATUS.AUTO_APPROVED]: '自动审核通过',
  [STATUS.UNVERIFIED]: '待人工审核',
  [STATUS.REFUSED]: '人工审核不通过',
  [STATUS.APPROVED]: '人工审核通过',
};
export const SALE_TYPES = [
  {
    value: '1001',
    text: '出售',
  },
  {
    value: '1002',
    text: '求购',
  },
  {
    value: '1003',
    text: '其他',
  },
];

export default Vue.extend({
  name: 'SaleDemandList',
  components: {},
  data() {
    const statusOptions = Object.entries(statusName).map(([value, text]) => ({
      value,
      text,
    }));
    statusOptions.unshift({ value: '', text: '全部' });
    return {
      STATUS,
      statusOptions,
      SALE_TYPES,
      loading: false,
      error: false,
      finished: false,
      size: 30,
      current: 0,
      total: 1,
      pages: 1,
      hasNext: true,
      records: [],

      detail: {},
      detailShow: false,
      rejectReasonShow: false,
      rejectId: '',
      rejectReason: '',
      params: {
        keywords: '',
        status: '',
      },
    };
  },
  methods: {
    editItem(item = {}) {
      this.detail = { ...item };
      this.detailShow = true;
    },
    saveItem() {

    },
    approveItem(item = {}) {
      this.$dialog.confirm({
        title: '确定',
        message: '确定审核通过吗？',
      }).then(() => {
        this.approveSalesStatus({
          id: item.id,
        });
      });
    },
    refuseItem(item = {}) {
      this.rejectId = '';
      this.rejectReason = '';
      this.$dialog.confirm({
        title: '确定',
        message: '确定拒绝吗？',
      }).then(() => {
        this.rejectReasonShow = true;
        this.rejectId = item.id;
      });
    },
    approveSalesStatus(params = {}) {
      sendRequest(approveSalesStatus, params).then((res) => {
        this.getData();
        this.$dialog.alert({
          message: '操作成功',
        });
      }).catch((e) => {
        console.log(e);
        this.$dialog.alert({
          message: `${e.message}`,
        });
      }).then(() => {
        this.$nextTick(() => {
          this.loading = false;
        });
      });
    },
    refuseSalesStatus(params = {}) {
      if (!this.rejectReason) {
        this.$dialog.alert({
          message: '请输入拒绝原因',
        });
        return;
      }
      sendRequest(refuseSalesStatus, {
        id: this.rejectId,
        rejectReason: this.rejectReason,
      }).then((res) => {
        this.getData();
        this.$dialog.alert({
          message: '操作成功',
        });
      }).catch((e) => {
        console.log(e);
        this.$dialog.alert({
          message: `${e.message}`,
        });
      }).then(() => {
        this.$nextTick(() => {
          this.loading = false;
        });
      });
    },
    getSalesInit() {
      sendRequest(getSalesInit).then((res) => {
      }).catch((e) => {
        console.log(e);
      }).then(() => {
        this.$nextTick(() => {
          this.loading = false;
        });
      });
    },
    exportData(e = {}) {
      this.$dialog.confirm({
        title: '确认',
        message: '确定立即下载人脉信息吗？',
      }).then(() => {
        const token = storage.local.get('token') || '';
        const link = document.createElement('a');
        link.style.display = 'none';
        link.href = `${config.DOWNLOAD_DOMAIN}/api/connections/report?token=${token}`;
        console.log(link.href);
        // 获取文件名
        // download 属性定义了下载链接的地址而不是跳转路径
        link.setAttribute('download', '人脉圈子.xlsx');
        document.body.appendChild(link);
        link.click();
      }).catch(() => {
        // on cancel
      });
    },
    loadMore() {
      if (this.pages <= this.current) {
        return;
      }
      this.getData(this.current + 1);
    },
    getData(page = 1) {
      // console.log(this.loading);
      this.error = false;
      sendRequest(getSalesList, {
        current: page,
        size: this.size,
        ...this.params,
      }).then((res) => {
        const {
          total = 1, records = [], pages = 1, hasNext = false,
        } = res;
        // eslint-disable-next-line eqeqeq
        if (page == 1) {
          this.records = records || [];
        } else {
          this.records = this.records.concat(records || []);
        }
        this.total = total;
        this.pages = pages;
        this.hasNext = hasNext;
        this.current = page;
        if (!this.hasNext || (records || []).length < this.size || this.records.length >= this.total) {
          this.finished = true;
        } else {
          this.finished = false;
        }
      }).catch((e) => {
        console.log(e);
        this.$dialog.alert({
          message: `${e.message}`,
        });
        this.error = true;
      }).then(() => {
        this.$nextTick(() => {
          this.loading = false;
        });
      });
    },
    goDetail(e = {}) {
      storage.local.set('busername', e.username || '');
      if (e.id) {
        this.$router.push(`/user/edit/${e.type === 3 ? 'hzdw' : 'bjs'}/${e.id || ''}`);
      } else {
        this.$router.push('/user/home');
      }
    },
    goNotice(e = {}) {
      this.$router.push('/notice/info');
    },
    goData(url) {
      this.$router.push(url || '/data/info');
    },
    goSet(e = {}) {
      // storage.local.set('busername', e.username || '');
      this.$router.push(`/user/sync/rule/${e.id || ''}`);
    },
    back() {
      // this.$router.back();
      this.$router.push('/home');
    },
  },
  created() {
    this.getSalesInit();
  },
});
</script>
<style scoped>
  .SaleDemandList {
    min-height: 100vh;
    background-color: #ffffff;
    font-size: 14px;
  }
  input, select {
    height: 26px;
    width: 110px;
    font-size: 14px;
    border: 1px solid #a7a9af;
    background-color: #ffffff;
    min-width: 100px;
    border-radius: 4px;
  }
  .keywords-input {
    width: 140px;
  }
  .date-select {
    width: 90px;
  }
  .button {
    min-width: 80px;
    height: 26px;
  }
</style>
